module.exports = __webpack_public_path__ + "static/abracademy-logo-4464baa4dc97ef7d8671f9d509003110.png";